// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"1358107a","453":"98276a77"}[chunkId] + ".chunk.js";
};